'use client';
import { createTheme } from '@mui/material';
import MuiAlert from '@/customThemes/components/MuiAlert';
import {
  MuiDialog,
  MuiDialogTitle,
  MuiDialogActions,
  MuiDialogContent,
  MuiDialogContentText,
} from '@/customThemes/components/MuiDialog';
import MuiButton from '@/customThemes/components/MuiButton';
import MuiCheckbox from '@/customThemes/components/MuiCheckbox';
import MuiRadio from '@/customThemes/components/MuiRadio';
import MuiInputBase from '@/customThemes/components/MuiInputBase';
import MuiTextField from '@/customThemes/components/MuiTextField';
// import MuiTooltip from '@/customThemes/components/MuiTooltip'; // TODO 确定UI是否要统一调整，整体适配全局样式

const theme = createTheme({
  cssVariables: true,
  typography: {
    fontFamily: 'var(--font-family)',
  },
  palette: {
    mode: 'light',
    primary: {
      main: '#CC0C1C',
    },
    secondary: {
      main: '#FF475D',
    },
  },
  components: {
    // @ts-ignore
    MuiButton,
    MuiAlert,
    MuiDialog,
    // @ts-ignore
    MuiDialogTitle,
    MuiDialogContent,
    MuiDialogContentText,
    MuiDialogActions,
    MuiRadio,
    MuiCheckbox,
    MuiInputBase,
    MuiTextField,
    // MuiTooltip,
  },
});

export default theme;
